var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDangerPopup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9019 2.41547C12.3065 2.2964 11.6935 2.2964 11.0981 2.41547C9.77522 2.68006 8.63523 3.5122 7.98005 4.69153L1.79413 15.8262C1.43727 16.4685 1.25 17.1912 1.25 17.926C1.25 20.3141 3.18588 22.25 5.57391 22.25H18.4261C20.8141 22.25 22.75 20.3141 22.75 17.926C22.75 17.1912 22.5627 16.4685 22.2059 15.8262L16.02 4.69153C15.3648 3.5122 14.2248 2.68006 12.9019 2.41547ZM12 13.75C11.5858 13.75 11.25 13.4142 11.25 13V9C11.25 8.58579 11.5858 8.25 12 8.25C12.4142 8.25 12.75 8.58579 12.75 9V13C12.75 13.4142 12.4142 13.75 12 13.75ZM12.75 16.5C12.75 16.9142 12.4142 17.25 12 17.25C11.5858 17.25 11.25 16.9142 11.25 16.5V16C11.25 15.5858 11.5858 15.25 12 15.25C12.4142 15.25 12.75 15.5858 12.75 16V16.5Z",
    fill: "#FFCACA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDangerPopup);
export default __webpack_public_path__ + "static/media/DangerPopup.d8b5977baee2df0d213c3ab0216d63e6.svg";
export { ForwardRef as ReactComponent };